import getItem from 'owa-mail-store/lib/services/getItem';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import { getBaseItemResponseShape } from 'owa-mail-store/lib/utils/getItemResponseShape';
import Item from 'owa-service/lib/contract/Item';
import Message from 'owa-service/lib/contract/Message';
import ItemInfoResponseMessage from 'owa-service/lib/contract/ItemInfoResponseMessage';
import { action } from 'satcheljs/lib/legacy';
import propertyUri from 'owa-service/lib/factory/propertyUri';

let updateCachedItem = function updateCachedItem(cachedItem: Item, responseItem: Item) {
    // Update whichever bodies were were able to fetch.
    if (responseItem.UniqueBody) {
        cachedItem.UniqueBody = responseItem.UniqueBody;
    }
    if (responseItem.NormalizedBody) {
        cachedItem.NormalizedBody = responseItem.NormalizedBody;
    }

    // Update the block status
    cachedItem.BlockStatus = responseItem.BlockStatus;
    cachedItem.HasBlockedImages = responseItem.HasBlockedImages;

    // Update message safety
    const responseMessage = responseItem as Message;
    if (responseMessage.MessageSafety) {
        (cachedItem as Message).MessageSafety = responseMessage.MessageSafety;
    }
};

updateCachedItem = action('updateCachedItem')(updateCachedItem);

export default async function getItemOnUnblockContent(item: Item) {
    const itemShape = getBaseItemResponseShape();
    itemShape.BlockExternalImagesIfSenderUntrusted = false;

    // Plan to fetch UniqueBody for an itemPart.
    let shapeName = 'ItemPart';

    if (!item.UniqueBody) {
        // If we don't have a UniqueBody, change the shapeName to get the NormalizedBody instead.
        shapeName = 'ItemNormalizedBody';
    } else if (item.NormalizedBody) {
        // If we have both, request NormalizedBody as an additionalProperty.
        itemShape.AdditionalProperties.push(propertyUri({ FieldURI: 'NormalizedBody' }));
    }

    const response = await getItem([item.ItemId.Id], itemShape, shapeName);
    if (checkIfResponseSuccess(response[0])) {
        const responseItem = response[0] as ItemInfoResponseMessage;
        updateCachedItem(item, responseItem.Items[0]);
        return Promise.resolve();
    } else {
        return Promise.reject();
    }
}
